import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import SectionHeader from "@/components/base/SectionHeader";
import { formatRating } from "@/utils/movies";

interface RankingListProps {
  movies: Movie[];
}

export default function RankingList({ movies }: RankingListProps) {
  return (
    <section>
      <SectionHeader title="高分榜单" subtitle="口碑与评分双高作品" moreHref="/search" moreLabel="更多榜单" />
      <ol className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {movies.map((movie, index) => (
          <li key={movie.id}>
            <Link
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-3 p-3 transition-colors hover:bg-background-100"
            >
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-label text-sm font-bold ${
                  index < 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <div className="h-14 w-11 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie.cover}
                  alt={movie.title}
                  title={`${movie.title} 海报`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                  {movie.title}
                </h3>
                <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">
                  {movie.year} · {movie.genres.join(" / ")}
                </p>
              </div>
              <span className="inline-flex shrink-0 items-center gap-0.5 font-label text-sm font-bold text-accent-600">
                <i className="ri-star-fill text-xs" aria-hidden="true" />
                {formatRating(movie.rating)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}